import React from 'react'
import { Link } from "react-router-dom";


const HomeServices = () => {
    return (
        <>
            <section className="services pt_115 xs_pt_95 pb_120 xs_pb_100" style={{ background: 'url(assets/images/services_bg.png)' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8 col-xl-6 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="section_heading left_heading mb_20">
                                <h5>Our Services</h5>
                                <h2>We Provide Service For You</h2>
                            </div>
                        </div>
                        {/* <div className="col-md-4 col-xl-6 text-end wow fadeInRight" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                            <Link className="common_btn" to="services.html">All Services<i className="far fa-long-arrow-right" aria-hidden="true" /></Link>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/property-dealer">
                                    <img src="assets/img/Property Dealer.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_1.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* Brooklyn Simmons */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link style={{ marginTop: "-45px" }} className="title" to="/property-dealer">Property Dealer</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <span>(20)</span>
                                    </p> */}
                                    <Link style={{ marginTop: "35px" }} className="book_now_btn" to="https://wa.me/+919174282618">book now</Link>
                                    <Link className="book_now_btn" to="/property-dealer" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/construction">
                                    <img src="assets/img/Construction.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_2.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* Jelly Tamang */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link style={{ marginTop: "-45px" }} className="title" to="/construction">Construction</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(41)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/construction" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/event-management">
                                    <img src="assets/img/Event Management.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_3.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* smith jhon */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/event-management" style={{ marginTop: "-45px" }}>Event Management</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <i className="far fa-star" aria-hidden="true" />
                                        <span>(20)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/event-management" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/financial-advisor">
                                    <img src="assets/img/Financial Advisor.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_4.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* susan singh */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/financial-advisor" style={{ marginTop: "-45px" }}>Financial Advisor</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(78)</span>
                                    </p> */}
                                    <Link className="book_now_btn" style={{ marginTop: "35px" }} to="https://wa.me/+919174282618">book now</Link>
                                    <Link className="book_now_btn" to="/financial-advisor" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/solar-energy">
                                    <img src="assets/img/Solar Energy.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_5.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* alan smith */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/solar-energy" style={{ marginTop: "-45px" }}>Solar Energy</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <span>(34)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/solar-energy" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/import-export">
                                    <img src="assets/img/Import Export.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_2.png" alt="provider" className="img-fluid w-100"  /> */}
                                            </div>
                                            {/* Jelly Tamang */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/import-export" style={{ marginTop: "-45px" }}>Import Export</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(17)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/import-export" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                    {/* <Link style={{padding:"8px 11px", marginLeft:"46px", textTransform:"capitalize"}} className="common_btn" to="services.html">All Services</Link> */}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/website-development">
                                    <img src="assets/img/Website Development.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_1.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* Brooklyn Simmons */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link style={{ marginTop: "-45px" }} className="title" to="/website-development">Website Development</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <span>(20)</span>
                                    </p> */}
                                    <Link style={{ marginTop: "35px" }} className="book_now_btn" to="https://wa.me/+919174282618">book now</Link>
                                    <Link className="book_now_btn" to="/website-development" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/company-registration">
                                    <img src="assets/img/Company Registration.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_2.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* Jelly Tamang */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link style={{ marginTop: "-45px" }} className="title" to="/company-registration">Company Registration</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(41)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/company-registration" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/gst-filing-itr-filing">
                                    <img src="assets/img/Gst Filing Itr Filing.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_3.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* smith jhon */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/gst-filing-itr-filing" style={{ marginTop: "-45px" }}>Gst Filing Itr Filing</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <i className="far fa-star" aria-hidden="true" />
                                        <span>(20)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/gst-filing-itr-filing" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/security-services">
                                    <img src="assets/img/Security Services.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_4.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* susan singh */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/security-services" style={{ marginTop: "-45px" }}>Security Services</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(78)</span>
                                    </p> */}
                                    <Link className="book_now_btn" style={{ marginTop: "35px" }} to="https://wa.me/+919174282618">book now</Link>
                                    <Link className="book_now_btn" to="/security-services" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/housekeeping-services">
                                    <img src="assets/img/Housekeeping Services.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_5.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* alan smith */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/housekeeping-services" style={{ marginTop: "-45px" }}>Housekeeping Services</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <span>(34)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/housekeeping-services" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/manpower-supply">
                                    <img src="assets/img/Manpower Supply.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_2.png" alt="provider" className="img-fluid w-100"  /> */}
                                            </div>
                                            {/* Jelly Tamang */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/manpower-supply" style={{ marginTop: "-45px" }}>Manpower Supply</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(17)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/manpower-supply" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                    {/* <Link style={{padding:"8px 11px", marginLeft:"46px", textTransform:"capitalize"}} className="common_btn" to="services.html">All Services</Link> */}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/facility-management">
                                    <img src="assets/img/Facility Management.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_1.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* Brooklyn Simmons */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link style={{ marginTop: "-45px" }} className="title" to="/facility-management">Facility Management</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <span>(20)</span>
                                    </p> */}
                                    <Link style={{ marginTop: "35px" }} className="book_now_btn" to="https://wa.me/+919174282618">book now</Link>
                                    <Link className="book_now_btn" to="/facility-management" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/electrical-services">
                                    <img src="assets/img/Electrical Services.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_2.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* Jelly Tamang */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link style={{ marginTop: "-45px" }} className="title" to="/electrical-services">Electrical Services</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(41)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/electrical-services" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/maintenance-repair">
                                    <img src="assets/img/Maintenance & Repair.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_3.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* smith jhon */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/maintenance-repair" style={{ marginTop: "-45px" }}>Maintenance & Repair</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <i className="far fa-star" aria-hidden="true" />
                                        <span>(20)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/maintenance-repair" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/customer-support">
                                    <img src="assets/img/Customer Support.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_4.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* susan singh */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/customer-support" style={{ marginTop: "-45px" }}>Customer Support</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(78)</span>
                                    </p> */}
                                    <Link className="book_now_btn" style={{ marginTop: "60px" }} to="https://wa.me/+919174282618">book now</Link>
                                    <Link className="book_now_btn" to="/customer-support" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/health-products">
                                    <img src="assets/img/Health Products.webp" alt="services" className="img-fluid w-100" />
                                    <span className="trending"><i className="fas fa-bolt" aria-hidden="true" /></span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_5.png" alt="provider" className="img-fluid w-100" /> */}
                                            </div>
                                            {/* alan smith */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/health-products" style={{ marginTop: "-45px" }}>Health Products & Wellness Solutions</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <span>(34)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/health-products" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_services">
                                <Link className="single_services_img" to="/business-partnership">
                                    <img src="assets/img/Business Partnership.webp" alt="services" className="img-fluid w-100" />
                                    <span className="new">new</span>
                                </Link>
                                <div className="single_services_text">
                                    <ul className="d-flex flex-wrap align-items-center">
                                        <li>
                                            <div className="img">
                                                {/* <img src="assets/images/small_img_2.png" alt="provider" className="img-fluid w-100"  /> */}
                                            </div>
                                            {/* Jelly Tamang */}
                                        </li>
                                        <li>
                                            <Link to="#"><i className="far fa-heart" aria-hidden="true" /></Link>
                                        </li>
                                    </ul>
                                    <Link className="title" to="/business-partnership" style={{ marginTop: "-45px" }}>Business Partnership & 
                                        <br/>Strategic Tie-up Opportunities</Link>
                                    {/* <p className="rating">
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star" aria-hidden="true" />
                                        <i className="fas fa-star-half-alt" aria-hidden="true" />
                                        <span>(17)</span>
                                    </p> */}
                                    <Link className="book_now_btn" to="https://wa.me/+919174282618" style={{ marginTop: "35px" }}>book now</Link>
                                    <Link className="book_now_btn" to="/business-partnership" style={{ marginTop: "35px", marginLeft: "55px" }}>Explore More</Link>

                                    {/* <Link style={{padding:"8px 11px", marginLeft:"46px", textTransform:"capitalize"}} className="common_btn" to="services.html">All Services</Link> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeServices